<template>
  <div class="review-and-prosecution">
    <Row class="detail-header">
      <span>审查起诉</span>
      <Button v-if="infoCtrl&&isDetailLoad" class="add-btn" type="primary" @click="openEdit">修改</Button>
    </Row>
    <Row class="case-content">
      <Row v-if="!infoCtrl&&isDetailLoad">
        <Form ref="formData" class="case-form" :model="formData" :rules="ruleValidate" :label-width="100">
          <FormItem label="构成刑事" prop="isCriminal">
            <RadioGroup v-model="formData.isCriminal">
              <Radio :disabled="defaultData?true:false" :label="1">是</Radio>
              <Radio :disabled="defaultData?true:false" :label="0">否</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem v-if="formData.isCriminal===0" label="情况说明" prop="remark">
            <Input v-model.trim="formData.remark" type="textarea" :autosize="{minRows: 3,maxRows: 8}" placeholder="请填写情况说明" />
          </FormItem>
          <Row v-else>
            <FormItem label="起诉时间" prop="prosecutionDate">
              <DatePicker
                transfer
                type="date"
                placeholder="请选择起诉时间"
                style="width:100%"
                format="yyyy-MM-dd"
                :value="formData.prosecutionDate"
                @on-change="getTime"
              />
            </FormItem>
            <FormItem label="法院名称" prop="court">
              <!-- <Input v-model="formData.court" placeholder="请输入法院名称"></Input> -->
              <mySelect ref="courtSelect"
                        :path="'/report/courts'"
                        :placeholder="'请选择管辖法院'"
                        :placeholder-input="'请输入管辖法院'"
                        :default-obj="defaultCourt"
                        :key-name="'name'"
                        @getValue="getCourtId"
              />
            </FormItem>
            <FormItem label="起诉内容" prop="content">
              <Input v-model.trim="formData.content" type="textarea" :autosize="{minRows: 3,maxRows: 8}" placeholder="请输入起诉内容(不超过512个字符)" />
            </FormItem>
            <FormItem label="是否逮捕" prop="isCatch">
              <RadioGroup v-model="formData.isCatch">
                <Radio :label="1">是</Radio>
                <Radio :label="0">否</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem
              v-for="(item,index) in formData.agents"
              v-if="formData.isCatch===1"
              :key="'agents.' + index"
              :label="index==0?'逮捕当事人':''"
              :prop="'agents.' + index"
              :rules="ruleValidate.agentsOne"
            >
              <div class="attorney-agent">
                <Input v-model="item.name" class="split-input" placeholder="请输入当事人" />
              </div>
              <div class="add-icon">
                <span v-if="index==0" class="icon-increase-01" @click="addAgent"></span>
                <span v-else class="icon-down-01" @click="removeAgent"></span>
              </div>
            </FormItem>
            <FormItem label="材料文件" prop="attachments">
              <file-upload
                :default-list="defaultList || []"
                :upload-config="{}"
                @getFileList="getAttachmentList"
              />
            </FormItem>
          </Row>
        </Form>
        <Row class="detail-btn-box">
          <Button type="primary" style="margin-right:10px;" :disabled="isSubmit" @click="submitNew">保存</Button>
          <Button v-if="defaultData" @click="infoCtrl=true">取消</Button>
        </Row>
      </Row>
      <Row v-if="infoCtrl&&isDetailLoad" class="detail-content">
        <Row><Col span="5" class="left-label">构成刑事：</Col><Col span="16" class="right-content">{{ defaultData.isCriminal?"是":"否" }}</Col></Row>
        <Row v-if="!defaultData.isCriminal">
          <Col span="5" class="left-label">情况说明：</Col>
          <Col span="16" class="right-content">{{ defaultData.remark }}</Col>
        </Row>
        <Row v-if="defaultData.isCriminal">
          <Row><Col span="5" class="left-label">起诉时间：</Col><Col span="16" class="right-content">{{ defaultData.prosecutionDate }}</Col></Row>
          <Row><Col span="5" class="left-label">法院名称：</Col><Col span="16" class="right-content">{{ defaultData.court }}</Col></Row>
          <Row><Col span="5" class="left-label">起诉内容：</Col><Col span="16" class="right-content">{{ defaultData.content }}</Col></Row>
          <Row><Col span="5" class="left-label">是否逮捕：</Col><Col span="16" class="right-content">{{ defaultData.isCatch?"逮捕成功":"逮捕失败" }}</Col></Row>
          <Row v-if="defaultData.isCatch"><Col span="5" class="left-label">逮捕当事人：</Col><Col span="16" class="right-content">{{ defaultData.catchLitigant }}</Col></Row>
          <Row>
            <Col span="5" class="left-label">材料文件：</Col>
            <Col span="16" class="right-content">
              <file-upload
                :default-list="defaultData.attachments || []"
                :upload-config="{readOnly:true}"
              />
            </Col>
          </Row>
        </Row>
      </Row>
    </Row>
  </div>
</template>
<script>
export default {
  components: {},
  props: ['processId', 'caseId'],
  data () {
    const isFillIn = (rule, value, callback) => {
      const arr = rule.fullField.split('.')
      const fillKey = arr[0]
      const fillIndex = arr[1]
      if (!this.formData[fillKey][fillIndex].name) {
        return callback(new Error('请填写逮捕当事人'))
      }
      if (this.formData[fillKey][fillIndex].name.length > 64) {
        return callback(new Error('不能超过64个字符'))
      }
      callback()
    }
    return {
      isDetailLoad: false,
      infoCtrl: true,
      isSubmit: false,
      defaultData: '',
      defaultList: [],
      litigantIdArr: [],
      formData: {
        isCriminal: 1,
        remark: '',
        prosecutionDate: '',
        court: '',
        courtId: '',
        content: '',
        isCatch: 1,
        agents: [
          {
            name: ''
          }
        ],
        attachments: []
      },
      defaultCourt: {},
      ruleValidate: {
        isCriminal: [{ required: true, type: 'number', message: '构成刑事不能为空', trigger: 'blur' }],
        prosecutionDate: [{ required: true, message: '起诉时间不能为空', trigger: 'blur' }],
        court: [{ required: true, message: '法院名称不能为空', trigger: 'blur' }, { max: 64, message: '不能超过64个字符', trigger: 'blur' }],
        isCatch: [{ required: true, type: 'number', message: '是否逮捕不能为空', trigger: 'blur' }],
        agents: [{ required: true, type: 'array', message: '逮捕当事人不能为空', trigger: 'blur' }],
        agentsOne: [{ required: true, validator: isFillIn, trigger: 'blur' }]
      }
    }
  },
  watch: {},
  created() {},
  beforeMount() {},
  mounted() {
    this.getDetail()
  },
  updated() {},
  methods: {
    getDetail() {
      const url = '/business/case/criminal/review-prosecution?processId=' + this.processId
      this.$get(url).then(res => {
        if (res.code == 0 && res.data) {
          this.defaultData = res.data
          this.infoCtrl = true
          this.giveDefaultData()
        } else {
          this.defaultData = ''
          this.infoCtrl = false
          this.isDetailLoad = true
        }
      })
    },
    // 获取管辖法院
    getCourtId(data) {
      this.formData.court = data.name
      this.formData.courtId = data.id
    },
    getTime(value) {
      this.formData.prosecutionDate = value
    },
    getAttachmentList(arr) {
      this.formData.attachments = []
      arr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formData.attachments.push(obj)
      })
    },
    addAgent() {
      this.formData.agents.push({ name: '' })
    },
    removeAgent(index) {
      this.formData.agents.splice(index, 1)
    },
    giveDefaultData() {
      this.formData.isCriminal = this.defaultData.isCriminal ? 1 : 0
      this.formData.remark = this.defaultData.remark
      this.formData.prosecutionDate = this.defaultData.prosecutionDate
      this.formData.court = this.defaultData.court
      this.formData.content = this.defaultData.content
      this.formData.isCatch = this.defaultData.isCatch ? 1 : 0
      this.formData.attachments = this.defaultData.attachments
      this.defaultList = this.defaultData.attachments
      this.formData.courtId = this.defaultData.courtId

      this.defaultCourt = {
        name: this.defaultData.court,
        id: this.defaultData.courtId
      }

      const arr = this.defaultData.catchLitigant ? this.defaultData.catchLitigant.split(',') : []
      if (arr.length > 0) {
        this.formData.agents = []
        arr.forEach((item, index) => {
          const obj = { name: item }
          this.formData.agents.push(obj)
        })
      }

      this.isDetailLoad = true
    },
    openEdit() {
      this.infoCtrl = false
      this.$nextTick(function() {
        this.$refs.courtSelect.voluation()
      })
    },
    submitNew() {
      const url = '/business/case/criminal/review-prosecution'
      const ajaxData = {
        processId: this.processId,
        caseId: this.caseId
      }
      if (this.formData.isCriminal === 1) {
        Object.assign(ajaxData, this.formData)
        ajaxData.catchLitigant = ''
        this.formData.agents.forEach((item, index) => {
          ajaxData.catchLitigant += index == 0 ? item.name : `,${item.name}`
        })
        delete ajaxData.agents
      } else {
        ajaxData.isCriminal = this.formData.isCriminal
        ajaxData.remark = this.formData.remark
      }
      if (this.defaultData) {
        ajaxData.id = this.defaultData.id
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$patch(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code == 0) {
                this.getDetail()
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        })
      } else {
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$post(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code == 0) {
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../civilCase/caseCommon.scss';
.attorney-agent{
    display: inline-block;
    width:calc(100% - 30px);
}
.add-icon{
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/view/criminalCase/reviewAndProsecution/index.vue